import ajax from '../../helpers/ajax'

export default {
  linkCampaignWithUnconfirmedUser({ state }, userToken) {
    ajax.put({
      url: state.linkUserUrl,
      data: {
        user_token: userToken
      },
      errorHandler: (response) => {
        window.errorLogger.error(`Error linking campaign with user: ${response}`)
      }
    })
  }
}
